import { ApisauceInstance } from 'apisauce';

/**
 * Adds one ad-hoc recognition payment to a driver's bonus record, with a note
 * and/or a label. Refused (400) when the program has not enabled the feature,
 * neither note nor label is given, the amount breaks a cap, or the period is
 * closed / archived. Returns the same body as the GET. (The gateway spec may
 * still show `note` as required; the deployed function accepts a label alone.)
 */
const postAdditionalPayment = ({
  api,
  driver,
  bonusProgramId,
  bonusDatasetRecordId,
  amount,
  note,
  label,
}: {
  api: ApisauceInstance;
  driver: string;
  bonusProgramId: string;
  bonusDatasetRecordId: string;
  amount: number;
  // At least one of note / label must be non-blank; blanks aren't sent.
  note?: string;
  label?: string;
}) => {
  return api.post<
    BonusTypes.AdditionalPayments.Response,
    BonusTypes.AdditionalPayments.ErrorResponse
  >(
    `/v1/driver_bonus/additional_payments?driver=${driver}&driver_bonus_program_id=${bonusProgramId}&bonus_dataset_record_id=${bonusDatasetRecordId}`,
    {
      amount,
      ...(note ? { note } : {}),
      ...(label ? { label } : {}),
    },
  );
};

export default postAdditionalPayment;
